import api from '../../api/moudles/remind'


const state = () => ({
	goodslist: [],

    CountOption:{
        title: {
            text: '最近短信发送数量与发送成功数'
        },
        tooltip: {
            trigger: 'axis',
            formatter(params) {
                var axisId = params[0].axisId
                var htmlStr = '';
                 for(var i=0;i<params.length;i++){
                   var param = params[i];
                   var xName = param.name;//x轴的名称
                   var seriesName = param.seriesName;//图例名称
                   var value = param.value;//y轴值
                   var color = param.color;//图例颜色
                   if(i==0){
                    htmlStr += xName +axisId.slice(1,5)+ '<br/>';//x轴的名称
                   }
                    htmlStr +='<div>';
                    htmlStr += '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:'+color+'"></span>';
                    htmlStr += seriesName + '：' + value ;
                    htmlStr += '</div>';
                 }
                  return htmlStr;
}
        },
        legend: {
            data: ['发送短信总数','发送成功数','成功支付数'],
            left:"50%"
        },
        grid: {
            left: '3%',
            right: '7%',
            bottom: '3%',
            containLabel: true
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        dataZoom: [
            {   
                type: 'slider', 
                start: 0,      
                end: 100         
            },
            {  
                type: 'inside', 
                start: 10,    
                end: 60 
            }
        ],
        xAxis: {
            name:"min",
            type: 'category',
            boundaryGap: false,
            data: []
        },
        yAxis: {
            type: 'value'
        },
        series: [
            {
                name: '发送短信总数',
                type: 'line',
                color:'#409EFF',
                smooth: true,
                data: []
            },
            {
                name: '发送成功数',
                type: 'line',
                data: [],
                smooth: true,
                color:'#67C23A',
            },
        ]
    },

    RemindRecordList:null,
    queryData:null,
    noteType:["发货提醒","催付提醒","签收提醒"],
    codSwitch:false,
})

const getters = {}

const actions = {

	// getShopAllItems({
	// 	commit
	// }, payload) {

	// 	api
	// 		.getShopAllItems(payload)
	// 		.then(res => {
	// 			if (res.code === 200) {
	// 				console.log(res.data)
	// 				commit(SET_GOODS_LIST, res.data)
	// 			}
	// 		})
	// }

	// getPayRemindEchart({state},payload) {
	// 	api.getPaymentStatistic(payload)
	// 		.then(res => {
    //             console.log(res)
    //             var key 
	// 			if (res.code == 'ok') {
    //                 var yarr = []

    //                 if(res.statisticMap[0]==undefined){
    //                     for(var i=0;i<25;i++){
    //                         yarr.push(0)
    //                     }
    //                     console.log(yarr)
    //                 }else{
    //                     var statisticMap = res.statisticMap
    //                     for(key in statisticMap){
    //                         yarr.push(statisticMap[key])
    //                     }
    //                 }
    //                 state.options.series[0].data = yarr
	// 			}
	// 		})
	// },

	// getPaymentRemindRecordList({state}) {
    //       api.getNoteRecords({
    //         pageNum:1,
    //         pageSize :10,
    //         shopId:2152236
    //       })
    //         .then(res => {

    //           var paymentRemindRecordList = res.noteRecords 
    //           console.log(state.noteType)
    //           for(var index in paymentRemindRecordList){
    //             paymentRemindRecordList[index].noteType_ = state.noteType[paymentRemindRecordList[index].noteType]
    //           }
    //           state.paymentRemindRecordList = paymentRemindRecordList
    //       })
	// },

    getPaymentRemindRecordBy({state},payload){
        api.getNoteRecordBy(payload)
        .then(res=>{
            if (res.code =='ok') {
                console.log(res)
                state.paymentRemindRecordList = res.noteRecord
            }
        })
    },


    getRemindSendCount({state},shopId){
        api.getRemindSendCount({
            loopTimes :30,
            noteType :1,
            period :2,
            shopId :shopId,
            status:'ALL'
        })
        .then(res1=>{
            var pyarr1 = []
            var pyarr2 = []
            for(var index in res1.statisticMap){
                pyarr1.push(res1.statisticMap[index])
            }
            state.paymentCountOption.series[0].data = pyarr1
            api.getRemindSendCount({
                loopTimes :30,
                noteType :1,
                period :2,
                shopId :shopId,
                status:'SUCCESS'
            })
            .then(res1_=>{
                for(var index in res1_.statisticMap){
                    pyarr2.push(res1_.statisticMap[index])
                }
                state.paymentCountOption.series[1].data = pyarr2
            })
        })


        api.getRemindSendCount({
            loopTimes :30,
            noteType :2,
            period :2,
            shopId :shopId,
            status:'ALL'
        })
        .then(res2=>{
            var shipyarr1 = []
            var shipyarr2 = []
            for(var index in res2.statisticMap){
                shipyarr1.push(res2.statisticMap[index])
            }
            state.shipmentCountOption.series[0].data = shipyarr1
            api.getRemindSendCount({
                loopTimes :30,
                noteType :2,
                period :2,
                shopId :shopId,
                status:'SUCCESS'
            })
            .then(res2_=>{
                for(var index in res2_.statisticMap){
                    shipyarr2.push(res2_.statisticMap[index])
                }
                state.shipmentCountOption.series[1].data = shipyarr2
            })
        })

        api.getRemindSendCount({
            loopTimes :30,
            noteType :3,
            period :2,
            shopId :shopId,
            status:'ALL'
        })
        .then(res3=>{
            var signyarr1 = []
            var signyarr2 = []
            for(var index in res3.statisticMap){
                signyarr1.push(res3.statisticMap[index])
            }
            state.signRemindCountOption.series[0].data = signyarr1
            api.getRemindSendCount({
                loopTimes :30,
                noteType :3,
                period :2,
                shopId :shopId,
                status:'SUCCESS'
            })
            .then(res3_=>{
                for(var index in res3_.statisticMap){
                    signyarr2.push(res3_.statisticMap[index])
                }
                state.signRemindCountOption.series[1].data = signyarr2
            })
        })
    },
    

    
}

const mutations = {
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
